<h3 mat-dialog-title i18n>
  Export
</h3>
<mat-dialog-content>
  <mat-form-field appearance="outline">
    <mat-label i18n>Booking item</mat-label>
    <textarea matInput readonly style="width: 100%;">
      {{ bookingItemToText() }}
    </textarea>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="onClose()" i18n>Close</button>
</mat-dialog-actions>
